import React from 'react';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { Lookup } from 'src/types/Lookup';
import { Box, Button, Typography, Checkbox, MenuItem, ListItemText, InputLabel, OutlinedInput, FormControl } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { styled } from '@mui/material/styles';



const ButtonError = styled(Button)(
    ({ theme }) => `
     background: ${theme.colors.error.main};
     color: ${theme.palette.error.contrastText};

     &:hover {
        background: ${theme.colors.error.dark};
     }
    `
);

interface WbBulkActionsProps {
    onBulkDelete: () => void;
    onBulkFiltersAdd: (lookupIds: any[]) => void;
    onBulkFiltersRemove: (lookupIds: any[]) => void;
    masterExerciseGroupFilterLookup: Lookup[]

}

export const WbBulkActions: React.FC<WbBulkActionsProps> = ({
    onBulkDelete,
    onBulkFiltersAdd,
    onBulkFiltersRemove,
    masterExerciseGroupFilterLookup
}) => {
    const [selectedOptions, setSelectedOptions] = React.useState<Lookup[]>([]);

    const handleChange = (event: SelectChangeEvent<string[]>) => {
        const {
            target: { value },
        } = event;

        const values: string[] = typeof value === "string" ? [value] : value;

        setSelectedOptions(masterExerciseGroupFilterLookup.filter(item => values.includes(item.name)));
    };

    return (
        <Box display="flex" alignItems="center">
            <Box display="flex" alignItems="center">
                <Typography variant="h5" color="text.secondary">
                    Bulk actions:
                </Typography>
                <ButtonError
                    sx={{ ml: 1 }}
                    startIcon={<DeleteTwoToneIcon />}
                    variant="outlined"
                    onClick={onBulkDelete}
                >
                    Delete
                </ButtonError>
            </Box>
            <Box display="flex" alignItems="center" ml={5}>
                <FormControl>
                    <InputLabel id="multiple-checkbox-label">Master Exercise Filter Grouping</InputLabel>
                    <Select
                        labelId="multiple-checkbox-label"
                        id="multiple-checkbox"
                        multiple
                        value={selectedOptions.map(option => option.name)}
                        onChange={handleChange}
                        input={<OutlinedInput label="Master Exercise Filter Grouping" />}
                        renderValue={(selected) => selected.join(', ')}
                        style={{ minWidth: 260, maxWidth: 320 }}
                    >
                        {masterExerciseGroupFilterLookup.map((option) => (
                            <MenuItem key={option.value} value={option.name}>
                                <Checkbox checked={selectedOptions.some(item => item.name === option.name)} />
                                <ListItemText primary={option.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Button onClick={() => onBulkFiltersAdd(selectedOptions.map(option => option.value))} disabled={selectedOptions.length === 0} sx={{ ml: 1 }}>
                    Add
                </Button>
                <Button onClick={() => onBulkFiltersRemove(selectedOptions.map(option => option.value))} disabled={selectedOptions.length === 0}>
                    Remove
                </Button>
            </Box>
        </Box>
    );
}
